/* LEGACY warnings remove lines below to see full warnings */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './Image.scss';

import clsx from 'clsx';
import Icon from 'design-system/Image/icon/Icon';
import MakeLink from 'design-system/MakeLink/MakeLink';
import { isNil } from 'lodash-es';

const Image = ({
  disabled,
  className,
  flag,
  hidden,
  title,
  name,
  folder,
  path,
  width,
  height,
  fallBackImg,
  tooltipPlacement = 'bottom',
  tooltipMaxWidth,
  tooltipTrigger = 'hover',
  tooltipHoverable,
  tooltipOffsetX,
  tooltipOffsetY,
  tooltipActions,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onBlur,
  onFocus,
  isLink,
  children,
  ariaLabel,
}: $TSFixMe) => (
  <MakeLink
    className={`icon-component ${isLink ? className : ''}`}
    title={title}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onBlur={onBlur}
    onFocus={onFocus}
    isLink={isLink}
    tooltipTrigger={tooltipTrigger}
    tooltipHoverable={tooltipHoverable}
    tooltipPlacement={tooltipPlacement}
    tooltipOffsetX={tooltipOffsetX}
    tooltipOffsetY={tooltipOffsetY}
    tooltipMaxWidth={tooltipMaxWidth}
    tooltipActions={tooltipActions}
  >
    <span
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any; reference: string; classNam... Remove this comment to see the full error message
      reference="true"
      className={clsx('icon-component', name, tooltipTrigger, { disabled, [className]: !isLink, flag, clickable: !isNil(onClick) })}
      hidden={hidden}
      aria-label={ariaLabel}
      onClick={(e) => {
        if (disabled) {
          return;
        }

        if (onClick) {
          onClick(e);
        }
      }}
      tabIndex={onClick ? 0 : -1}
    >
      {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ name: any; folder: any; path: any; fallBac... Remove this comment to see the full error message */}
      {children || <Icon name={name} folder={folder} path={path} fallBackImg={fallBackImg} width={width} height={height} />}
    </span>
  </MakeLink>
);

export default Image;
